import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'
import { brandColors, brandFonts } from '../../styled/brand'
import { Wrap } from './Wrap'
import LogoMark from './LogoMark'

/**
 * Shared lightweight nav rendered on every page EXCEPT Home (Home carries its
 * logo inline in the hero instead). A non-fixed cream bar: logo/wordmark left
 * linking to `/`, a single coral "Home" link right. Deliberately does not link
 * to How It Works (out of scope). Stacks to a centered column below 900px.
 */
const NavInner = styled(Wrap)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: 28,
  paddingBottom: 28,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 16,
  },
}))

const HomeLink = styled(Link)({
  fontFamily: brandFonts.heading,
  fontWeight: 600,
  fontSize: 14,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: brandColors.coralText,
  textDecoration: 'none',
})

const SiteNav = () => (
  <Box component="nav" sx={{ background: brandColors.cream }}>
    <NavInner>
      <Box component={Link} to="/" sx={{ textDecoration: 'none', color: brandColors.nearBlack2 }}>
        <LogoMark iconSize={24} fontSize={17} />
      </Box>
      <HomeLink to="/">Home</HomeLink>
    </NavInner>
  </Box>
)

export default SiteNav
